import React, { useEffect, useState } from "react";
import {
  PaymentElement,
  LinkAuthenticationElement,
  useStripe,
  useElements,
  AddressElement,
} from "@stripe/react-stripe-js";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import { call } from "services/axiosService/core";
import PropTypes from "prop-types";
import { useMaterialUIController } from "context";
// import profilesListData from "layouts/pages/profile/profile-overview/data/profilesListData";
import Typography from "@mui/material/Typography";
import * as Sentry from "@sentry/browser";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// --- Inner Form Component (Requires <Elements> wrapper) ---
export default function AddPaymentMethod({
  clientSecret,
  handleClose,
  setAlertMessage,
  setOpenSnackbar,
  setSeverity,
  childDetails,
}) {
  const stripe = useStripe();
  const navigate = useNavigate();
  const elements = useElements();
  const [isStripeReady, setIsStripeReady] = useState(false);

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [controller] = useMaterialUIController();
  const { profile } = controller;
  const { t } = useTranslation();

  useEffect(() => {
    if (!stripe) {
      return;
    }
    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }
  }, [stripe]);

  const handleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    if (!stripe || !elements) return;

    const paymentRedirectDetails = {
      checkoutProcess: "addPayment",
      childDetails: childDetails,
    };

    try {
      localStorage.setItem("payment_redirect_details", JSON.stringify(paymentRedirectDetails));
    } catch (error) {
      setMessage("An unexpected error has occurred");
      setIsLoading(false);
      return;
    }

    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/payment_redirect`,
      },
      redirect: "if_required",
    });

    if (error) {
      setAlertMessage(t("alerts.addPayment.error"));
      setSeverity("error");
      setIsLoading(false);
      setOpenSnackbar(true);
    }

    if (setupIntent && setupIntent.status == "succeeded") {
      setIsLoading(false);
      setAlertMessage(t("alerts.addPayment.success"));
      setSeverity("success");
      setOpenSnackbar(true);
      handleClose();
    } else if (setupIntent && setupIntent.status == "processing") {
      navigate(
        "/payment_redirect?setup_intent=" +
          setupIntent.id +
          "&setup_intent_client_secret=" +
          setupIntent.client_secret +
          "&redirect_status=" +
          setupIntent.status
      );
    } else {
      setAlertMessage(t("alerts.addPayment.error"));
      setSeverity("error");
      setIsLoading(false);
      setOpenSnackbar(true);
    }
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  const LinkAuthenticationElementOptions = {
    defaultValues: { email: profile.email },
  };
  const AddressElementOptions = {
    mode: "billing",
  };

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      {/* <LinkAuthenticationElement
        id="link-authentication-element"
        options={LinkAuthenticationElementOptions}
        onChange={(e) => setEmail(e.value.email)}
      /> */}
      <PaymentElement
        id="payment-element"
        options={paymentElementOptions}
        onReady={() => setIsStripeReady(true)}
      />
      <Typography
        sx={{ display: "flex", alignItems: "center" }}
        variant="h6"
        textAlign="left"
        m={2}
      >
        <span style={{ color: "red", fontSize: "small", paddingRight: "5px" }}>*</span>
        {t("headings.billingAddress")}
        <span style={{ color: "red", fontSize: "small", marginLeft: "10px" }}>Required</span>
      </Typography>
      <AddressElement id="adress-element" options={AddressElementOptions} />
      {isStripeReady && (
        <MDBox px={2} py={2} display="flex" justifyContent="end">
          <MDButton
            disabled={isLoading || !stripe || !elements}
            type="submit"
            id="submit"
            style={{
              color: "white",
              background: isLoading || !stripe || !elements ? "#b0bec5" : "#10B0D5",
              marginTop: "15px",
              cursor: isLoading || !stripe || !elements ? "not-allowed" : "pointer",
            }}
          >
            <span id="button-text">
              {isLoading ? t("buttonTitles.Processing") : t("buttonTitles.savePaymentMethod")}
            </span>
          </MDButton>
        </MDBox>
      )}
    </form>
  );
}
